<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup MST_008
 * @created at      :   2026/01/27
 * @created by      :   longvv
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import store from '@/store';
import template from './template.html';
import { mapState, mapMutations, mapActions } from 'vuex';
import PopupMST008 from '@/views/popupSearch/PopupMST008/store';
import helpers from '@/utils/helpers';

var PopupMST008Index = {
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number, Object],
        isShowFooter: Boolean
    },
    beforeCreate() {
        if (!store.hasModule('PopupMST008')) {
            store.registerModule('PopupMST008', PopupMST008);
        }
    },
    created() {
        this.onInitScreen();
        this.applyInitData();
        this.onSearchItem();
    },
    data() {
        return {};
    },
    emits: ['close', 'onReferModelValue', 'onReferValueName'],
    computed: {
        ...mapState('PopupMST008', ['listData', 'data', 'totalRows', 'msgNoData'])
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        ...mapActions('PopupMST008', ['searchMst008Info']),
        ...mapMutations('PopupMST008', ['resetDataInit', 'setPageNavigation', 'setPageNo']),
        applyInitData() {
            if (this.initData && typeof this.initData === 'object') {
                if (this.initData.company_cd !== undefined) {
                    this.data.company_cd = this.initData.company_cd;
                }
                if (this.initData.center_cd !== undefined) {
                    this.data.center_cd = this.initData.center_cd;
                }
                if (this.initData.department_cd !== undefined) {
                    this.data.department_cd = this.initData.department_cd;
                }
                if (this.initData.group_cd !== undefined) {
                    this.data.group_cd = this.initData.group_cd;
                }
                if (this.initData.office_cd !== undefined) {
                    this.data.office_cd = this.initData.office_cd;
                }
                if (this.initData.mode_approver !== undefined) {
                    this.data.mode_approver = this.initData.mode_approver;
                }
            }
        },
        onSearchItem() {
            this.setPageNavigation({
                currentPage: 1,
                perPage: this.data.pageSize
            });
            this.searchMst008Info(this.data);
        },
        changeCurrentPage(data) {
            this.data.pageNo = data.currentPage;
            this.data.pageSize = data.perPage;
            this.searchMst008Info(this.data);
        },
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        chooseItem(item) {
            this.$emit('onReferModelValue', item.user_cd);
            this.$emit('onReferValueName', item.user_name);
            this.$emit('close');
        }
    }
};
export default PopupMST008Index;
</script>

<style lang="scss">
@use '@/assets/scss/common/popup.scss' as *;
</style>
